// src/router.ts
import { createRouter, createWebHistory } from 'vue-router'

// 1. Definition der Routen (SEO-optimiert)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../components/HomeView.vue'),
    meta: {
      title: 'Webdesign & Hilfsmittelberatung in Wetzlar | DigitalBrücke by Marc',
      description: 'Professionelles Webdesign und Hilfsmittelberatung in Wetzlar. Unterstützung bei Webseiten, Smartphones und Netzwerken.'
    }
  },

  {
    path: '/leistungen',
    name: 'Leistungen',
    component: () => import('../components/OfferView.vue'),
    meta: {
      title: 'Leistungen | Webdesign & IT Service Wetzlar',
      description: 'Unsere Leistungen: Webdesign, Hilfsmittelberatung, IT Hilfe und Netzwerk-Einrichtung in Wetzlar.'
    }
  },

  {
    path: '/ueber-mich',
    name: 'Über Mich',
    component: () => import('../components/AboutMeView.vue'),
    meta: {
      title: 'Über mich | DigitalBrücke by Marc',
      description: 'Lerne Marc kennen – dein Ansprechpartner für Webdesign, Hilfsmittel und Netzwerkaufbau in Wetzlar.'
    }
  },

  {
    path: '/avatar-marc',
    name: 'AvatarMarc',
    component: () => import('../components/AvatarMarcView.vue'),
    meta: {
      title: 'Avatar Marc | DigitalBrücke',
      description: 'Lerne den digitalen Avatar von Marc kennen.'
    }
  },

  {
    path: '/it-wissen',
    name: 'Wissenswertes',
    component: () => import('../components/WissenView.vue'),
    meta: {
      title: 'IT Wissen & Tipps | DigitalBrücke',
      description: 'Hilfreiche IT Tipps, Anleitungen und Wissen rund um Computer, Internet und Technik.'
    }
  },

  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../components/ImpressumView.vue'),
    meta: {
      title: 'Impressum | DigitalBrücke',
      description: 'Rechtliche Informationen und Impressum.'
    }
  },

  {
    path: '/webdesign-wetzlar',
    name: 'Webdesign',
    component: () => import('../components/WebseitenProgrammierungView.vue'),
    meta: {
      title: 'Webdesign Wetzlar | Moderne Webseiten erstellen lassen',
      description: 'Individuelles Webdesign in Wetzlar. Moderne, schnelle und SEO-optimierte Webseiten für dein Unternehmen.'
    }
  },

  {
    path: '/neuigkeiten',
    name: 'Neuigkeiten',
    component: () => import('../components/NeuigkeitenView.vue'),
    meta: {
      title: 'Neuigkeiten & Updates | DigitalBrücke',
      description: 'Aktuelle Neuigkeiten, Updates und Entwicklungen rund um DigitalBrücke.'
    }
  },

  {
    path: '/it-hilfe-wetzlar',
    name: 'Hilfsmittel',
    component: () => import('@/components/HilfsmittelView.vue'),
    meta: {
      title: 'IT Hilfe & Hilfsmittelberatung Wetzlar',
      description: 'Unterstützung bei IT Problemen und Hilfsmitteln in Wetzlar. Computer, Smartphones und mehr.'
    }
  },

  {
    path: '/heimnetzwerk-einrichten',
    name: 'Heimnetzwerk',
    component: () => import('../components/NetHouse.vue'),
    meta: {
      title: 'Heimnetzwerk einrichten | IT Hilfe Wetzlar',
      description: 'Hilfe beim Einrichten deines Heimnetzwerks in Wetzlar – schnell und zuverlässig.'
    }
  },

  {
    path: '/apple-hilfe',
    name: 'Apple Hilfe',
    component: () => import('../components/AppleView.vue'),
    meta: {
      title: 'Apple Hilfe Wetzlar | iPhone, Mac & Co.',
      description: 'Unterstützung für Apple Geräte wie iPhone, iPad und Mac in Wetzlar.'
    }
  },

  {
    path: '/android-hilfe',
    name: 'Android Hilfe',
    component: () => import('../components/SmartphoneAndrView.vue'),
    meta: {
      title: 'Android Hilfe Wetzlar | Smartphone Support',
      description: 'Hilfe bei Android Smartphones – Einrichtung, Probleme und Optimierung in Wetzlar.'
    }
  },

  {
    path: '/webinare-it-schulungen',
    name: 'Webinare',
    component: () => import('../components/WebinareView.vue'),
    meta: {
      title: 'Webinare & IT Schulungen | DigitalBrücke',
      description: 'Online Webinare und Schulungen rund um IT, Internet und digitale Themen.'
    }
  },

  {
    path: '/partner',
    name: 'Partner',
    component: () => import('../components/MyPartner.vue'),
    meta: {
      title: 'Partner | DigitalBrücke',
      description: 'Unsere Partner und Kooperationen im Bereich IT und Web.'
    }
  }
]

// 2. Router erstellen
const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior() {
    return { top: 0 }
  }
})

// 3. Dynamische Meta-Tags setzen
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'DigitalBrücke'

  const description = document.querySelector('meta[name="description"]')
  if (description && to.meta && to.meta.description) {
    description.setAttribute('content', to.meta.description)
  }

  next()
})

export default router